<div class="partner-detail-header h-100 d-flex align-items-center">
    <app-back-arrow-button class="back-button d-block" (buttonClick)="onNavigation()"></app-back-arrow-button>
    <div *ngIf="isPartnerImageShown && (partnerLogoUrl$ | async) as logo" class="partner-logo" [appSetBackgroundImage]="logo"></div>
    <div class="partner-name">{{partnerName$ | async}}</div>
</div>
